import { Components } from "appworks/components/components";
import { gameState } from "appworks/model/game-state";
import { Record } from "appworks/model/gameplay/records/record";
import { Services } from "appworks/services/services";
import { UIFlag, uiFlags } from "appworks/ui/flags/ui-flags";
import { Contract } from "appworks/utils/contracts/contract";
import { GambleCollectCommand } from "slotworks/commands/comms/gamble-collect-command";
import { GambleInitCommand } from "slotworks/commands/comms/gamble-init-command";
import { GambleComponent } from "slotworks/components/gamble/gamble-component";
import { GambleRecord } from "slotworks/model/gameplay/records/gamble-record";
import { SpinRecord } from "slotworks/model/gameplay/records/spin-record";
import { Idle } from "slotworks/state-machine/standard/states/idle";

export class IdleGamble extends Idle {
    protected collecting: boolean = false;

    public onEnter(): void {
        this.collecting = false;

        const record: Record = gameState.getCurrentGame().getCurrentRecord();
        if (record && record.gamble) {
            this.signalBindings.push(Components.get(GambleComponent).onGambleStart.add(() => this.onGambleStart()));
            this.signalBindings.push(Components.get(GambleComponent).onGambleCollect.add(() => this.onGambleCollect()));
            this.signalBindings.push(Services.bet.onBetChange.add(() => this.onGambleCollect()));
            uiFlags.set(UIFlag.GAMBLE, true);
        }

        super.onEnter();
    }

    public onSkip(): void {
        const record: Record = gameState.getCurrentGame().getCurrentRecord();
        if (record && record.gamble) {
            if (!this.collecting) {
                this.collecting = true;
                uiFlags.set(UIFlag.GAMBLE, false);
                this.collect().then(() => {
                    super.onSkip();
                    this.collecting = false;
                });
            }
        } else if (!this.collecting) {
            super.onSkip();
        }
    }

    protected onGambleStart(): void {
        this.clearSignalBindings();
        const record = gameState.getCurrentGame().getCurrentRecord();
        if (record && (record instanceof SpinRecord || record instanceof GambleRecord)) {
            GambleInitCommand().then(() => {
                gameState.getCurrentGame().nextRecord();
                this.complete();
            });
        } else {
            this.complete();
        }
    }

    protected onGambleCollect(): void {
        if (!this.collecting) {
            this.collecting = true;
            uiFlags.set(UIFlag.GAMBLE, false);
            this.collect().then(() => {
                this.collecting = false;
            });
        }
    }

    protected collect(): Contract<void> {
        this.clearSignalBindings();
        uiFlags.set(UIFlag.AWAITING_RESPONSE, true);
        return new Contract<void>((resolve) => {
            GambleCollectCommand().then(() => {
                uiFlags.set(UIFlag.AWAITING_RESPONSE, false);
                const record: Record = gameState.getCurrentGame().getCurrentRecord();
                record.gamble = false;

                resolve();
            });
        });
    }
}
